// extracted by mini-css-extract-plugin
export default {"center":"Status_center__HHG8S","content":"Status_content__QkSCR"};